export enum GermanStates {
  BadenWuerttemberg = "Baden-Württemberg",
  Bavaria = "Bavaria",
  Berlin = "Berlin",
  Brandenburg = "Brandenburg",
  Bremen = "Bremen",
  Hamburg = "Hamburg",
  Hessen = "Hessen",
  LowerSaxony = "Lower Saxony",
  NorthRhineWestphalia = "North Rhine-Westphalia",
  RhinelandPalatinate = "Rhineland-Palatinate",
  Saarland = "Saarland",
  Saxony = "Saxony",
  SaxonyAnhalt = "Saxony-Anhalt",
  SchleswigHolstein = "Schleswig-Holstein",
  Thuringia = "Thuringia",
  MecklenburgVorpommern = "Mecklenburg-Vorpommern",
}

interface Doctor {
  doctorsName: string
  officeName: string
  address: string
  state: GermanStates
  phone: string
  email?: string
  lat: number
  lon: number
  webAddress: string
}

// 1. Zeile 8 – Hamburg
const behrmann: Doctor = {
  doctorsName: "Dr. med. Renate Behrmann",
  officeName: "Praxis Behrmann & Poel",
  address: "Weidenbaumsweg 6, 21029 Hamburg",
  state: GermanStates.Hamburg,
  phone: "040 7243755",
  email: undefined,
  lat: 53.48972820529068,
  lon: 10.207783,
  webAddress: "https://www.hautarzt-bergedorf.de",
}

// 2. Zeile 30 – Bremen
const elsner: Doctor = {
  doctorsName: "Prof. Dr. med. Jörn Elsner",
  officeName: "MVZ Hautarzt- und Laserzentrum Bremen",
  address: "Wachmannstr. 7, 28209 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 3032100",
  email: "info@hautarzt-elsner.de",
  lat: 53.084656,
  lon: 8.826995,
  webAddress: "https://www.hautarzt-elsner.de",
}

// 3. Zeile 31 – Göttingen
const goppold: Doctor = {
  doctorsName: "Angela Goppold",
  officeName: "Hautarztpraxis Angela Goppold",
  address: "Kurze Geismarstraße 10, 37073 Göttingen",
  state: GermanStates.LowerSaxony,
  phone: "0551 484499",
  email: undefined,
  lat: 51.53047742378146,
  lon: 9.938663039789267,
  webAddress: "https://www.praxisgoppold.de",
}

const huerkamp: Doctor = {
  doctorsName: "Dr. med. Christina Huerkamp",
  officeName: "Hautarztpraxis Dres. Huerkamp/Schuster",
  address: "Gottfried-Disse-Str. 42, 53879 Euskirchen",
  state: GermanStates.NorthRhineWestphalia,
  phone: "02251 7749466",
  email: "info@dermatologie-euskirchen.de",
  lat: 50.64378956282412,
  lon: 6.791180551332285,
  webAddress: "https://www.dermatologie-euskirchen.de",
}

const schuster: Doctor = {
  doctorsName: "Dr. med. Andrea Schuster",
  officeName: "Hautarztpraxis Dres. Huerkamp/Schuster",
  address: "Gottfried-Disse-Str. 42, 53879 Euskirchen",
  state: GermanStates.NorthRhineWestphalia,
  phone: "02251 7749466",
  email: "info@dermatologie-euskirchen.de",
  lat: 50.64378956282412,
  lon: 6.791180551332285,
  webAddress: "https://www.dermatologie-euskirchen.de",
}

const alJebori: Doctor = {
  doctorsName: "Abdulkareem Al-Jebori",
  officeName: "Haut- und Laserpraxis Hagen",
  address: "Elberfelder Str. 78, 58095 Hagen",
  state: GermanStates.NorthRhineWestphalia,
  phone: "02331 15047",
  email: undefined,
  lat: 51.35892868041992,
  lon: 7.468045711517334,
  webAddress: "https://www.haut-laserpraxis-hagen.de",
}

const eilers: Doctor = {
  doctorsName: "Dr. med. Alexandra Eilers",
  officeName: "Curaderm Hautarztpraxis Lohne",
  address: "Lindenstr. 13-15, 49393 Lohne",
  state: GermanStates.LowerSaxony,
  phone: "04442 911110",
  email: "lohne@curaderm.de",
  lat: 52.670677185058594,
  lon: 8.247243881225586,
  webAddress: "https://www.curaderm.de",
}

const hoffmann: Doctor = {
  doctorsName: "Dr. med. Karl Hoffmann",
  officeName: "Curaderm Hautarztpraxis Lohne",
  address: "Lindenstr. 13-15, 49393 Lohne",
  state: GermanStates.LowerSaxony,
  phone: "04442 911110",
  email: "lohne@curaderm.de",
  lat: 52.670677185058594,
  lon: 8.247243881225586,
  webAddress: "https://www.curaderm.de",
}

const zobel: Doctor = {
  doctorsName: "Markus Zobel",
  officeName: "Curaderm Hautarztpraxis Lohne",
  address: "Lindenstr. 13-15, 49393 Lohne",
  state: GermanStates.LowerSaxony,
  phone: "04442 911110",
  email: "lohne@curaderm.de",
  lat: 52.670677185058594,
  lon: 8.247243881225586,
  webAddress: "https://www.curaderm.de",
}

const dettmann: Doctor = {
  doctorsName: "Dr. Judith Dettmann",
  officeName: "Curaderm Hautarztpraxis Elsfleth",
  address: "Rittersweg 4-6, 26931 Elsfleth",
  state: GermanStates.LowerSaxony,
  phone: "04404 926330",
  email: "elsfleth@curaderm.de",
  lat: 53.236,
  lon: 8.46,
  webAddress: "https://www.curaderm.de",
}

const francois: Doctor = {
  doctorsName: "Mateja Francois",
  officeName: "Curaderm Hautarztpraxis Garrel",
  address: "Hauptstraße 12, 49681 Garrel",
  state: GermanStates.LowerSaxony,
  phone: "04474 200930",
  email: "garrel@curaderm.de",
  lat: 52.9573,
  lon: 8.025894165039062,
  webAddress: "https://www.curaderm.de",
}

const huening: Doctor = {
  doctorsName: "Dr. med. Svea Hüning",
  officeName: "Hautarztpraxis Schwelm Dr. Svea Hüning & Team",
  address: "Barmer Straße 13a, 58332 Schwelm",
  state: GermanStates.NorthRhineWestphalia,
  phone: "+49 2336 9209022",
  email: "info@hautarztpraxis-schwelm.de",
  lat: 51.281364,
  lon: 7.28242445,
  webAddress: "https://www.hautarztpraxis-schwelm.de",
}
const le: Doctor = {
  doctorsName: "Dr. med. Anh Le",
  officeName: "Hautarztpraxis Le",
  address: "Robert-Koch-Straße 17d, 84489 Burghausen",
  state: GermanStates.Bavaria,
  lat: 48.1711694,
  lon: 12.8279275,
  phone: "+49 86773841",
  email: "info@hautarztpraxis-le.de",
  webAddress: "https://www.hautarztpraxis-le.de/home"
}

const ueberschaar: Doctor = {
  doctorsName: "Herr Dr. med. Simon Ueberschaar",
  officeName: "Dermatologie und Ästhetik Dr. med. univ. Simon Ueberschaar",
  address: "Hochstraße 58, 87527 Sonthofen",
  state: GermanStates.Bavaria,
  phone: "+49 8321 3719",
  email: "info@dermatologie-ueberschaar.de",
  lat: 47.51211929321289,
  lon: 10.280113220214844,
  webAddress: "https://dermatologie-ueberschaar.de",
}

const mueller: Doctor = {
  doctorsName: "Frau Dr. med. Verena Müller",
  officeName: "Dermatologie und Ästhetik Dr. med. univ. Simon Ueberschaar",
  address: "Hochstraße 58, 87527 Sonthofen",
  state: GermanStates.Bavaria,
  phone: "+49 8321 3713",
  email: "info@dermatologie-ueberschaar.de",
  lat: 47.51211929321289,
  lon: 10.280113220214844,
  webAddress: "https://dermatologie-ueberschaar.de",
}

const matzke: Doctor = {
  doctorsName: "Frau Dr. med. Silke Matzke",
  officeName: "Hautarztpraxis Dr. Matzke",
  address: "Waller Heerstraße 10, 28219 Bremen",
  state: GermanStates.Bremen,
  phone: "+49 421 384902",
  email: "info@hautarzt-matzke.de",
  lat: 53.10094098917633,
  lon: 8.787269839802404,
  webAddress: "https://hautarzt-matzke.de/",
}

const schwichtenberg: Doctor = {
  doctorsName: "Dr. Uwe Schwichtenberg",
  officeName: "Derma Nord",
  address: "Kaffeestraße 2, 28779 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 601066",
  email: "anmeldung@derma-nord.de",
  lat: 53.181835899999996,
  lon: 8.575369914538852,
  webAddress: "https://www.derma-nord.de",
}

const lucka: Doctor = {
  doctorsName: "Dr. Tilmann Lucka",
  officeName: "Dermatologie am Markt",
  address: "Am Markt 11, 28195 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 327636",
  lat: 53.075963,
  lon: 8.8067,
  webAddress: "https://hautarzt-lucka.de",
}

const toepfer: Doctor = {
  doctorsName: "Dr. Michael Töpfer",
  officeName: "Gemeinschaftspraxis Dießenbacher/ Töpfer/ Tams",
  address: "Kurfürstenallee 9, 28211 Bremen",
  state: GermanStates.Bremen,
  email: "info@hautarzt-diessenbacher.de",
  phone: "0421 3469911",
  lat: 53.081268,
  lon: 8.840352,
  webAddress: "https://www.derma-dtt.de",
}

const quitschau: Doctor = {
  doctorsName: "Dr. Viktoria Quitschau",
  officeName: "Praxis Viktoria Quitschau",
  address: "Sülztorstr. 41, 21335 Lüneburg",
  state: GermanStates.LowerSaxony,
  email: "derma.lueneburg@gmail.com",
  phone: "04131 41295",
  lat: 53.242583,
  lon: 10.403777,
  webAddress: "https://derma-lg.de",
}

const jagow: Doctor = {
  doctorsName: "Dr. Johanna Jagow",
  officeName: "Praxis Dr. Johanna Jagow",
  address: "Arnoldigasse 2, 34414 Warburg",
  state: GermanStates.NorthRhineWestphalia,
  email: null,
  phone: "05641 7454020",
  lat: 51.4850323,
  lon: 9.147709,
  webAddress: "https://hautarztpraxis-jagow.de/unser-team/",
}

const overbeck: Doctor = {
  doctorsName: "Dr. Cora Lu Overbeck",
  officeName: "Hautärztliche Gemeinschaftspraxis Neumann/Dr. Overbeck",
  address: "Lange Strasse 53, 34345 Hann. Münden",
  state: GermanStates.LowerSaxony,
  email: "info@derma-praxis.eu",
  phone: "05541 2447",
  lat: 51.416775,
  lon: 9.651786,
  webAddress: "https://www.hautarztpraxis-hann-muenden.de",
}

const ekanayakeBohlig: Doctor = {
  doctorsName: "Dr. Swarna Ekanayake-Bohlig",
  officeName: "Ärztehaus Rahlstedt - Dr. med. Silke Tinger/Dr.med.Swarna Ekanayake-Bohlig",
  address: " Rahlstedter Bahnhofstraße 23-25, 22143 Hamburg",
  state: GermanStates.Hamburg,
  email: "info@skinuvita.de",
  phone: "042139913472",
  lat: 53.603905,
  lon: 10.15514,
  webAddress: "https://www.kvhh.net/de/medicalregister/net-kvhh-physician-40751-24828.html",
}

const wagner: Doctor = {
  doctorsName: "Dr. Aline Wagner",
  officeName: "Hautarztpraxis am Mühlenkamp",
  address: "Mühlenkamp 34A, 22303 Hamburg",
  state: GermanStates.Hamburg,
  email: "info@skinuvita.de",
  phone: "042139913472",
  lat: 53.58221,
  lon: 10.01125,
  webAddress: "https://hautarzt-bramfeld.de",
}

const cramer: Doctor = {
  doctorsName: "Dres. med. Cramer und Kollegen",
  officeName: "Hautärztliche Gemeinschaftspraxis Dres. med. Cramer und Kollegen",
  address: "Weberstraße 18, 45879 Alt-Gelsenkirchen ",
  state: GermanStates.NorthRhineWestphalia,
  email: "praxis@hautarzt-cramer.de",
  phone: "0209207900",
  lat: 51.507001,
  lon: 7.10168,
  webAddress: "https://hautarzt-cramer.de",
}

const drerup: Doctor = {
  doctorsName: "Dr. Christian Drerup",
  officeName: "Hautarztpraxis Prof. Haufs",
  address: "Wolbeckerstr. 21, 48155 Münster",
  state: GermanStates.NorthRhineWestphalia,
  email: null,
  phone: "0251 539 530 10",
  lat: 51.9586617,
  lon: 7.6383079,
  webAddress: "https://www.hautarzt-haufs.de",
}

const haase: Doctor = {
  doctorsName: "Dr. Ozan Haase",
  officeName: "Hautarztpraxis Prof. Krengel / Dr. Mrowka / Dr. Haase ",
  address: "Lindenplatz 6, 23554 Lübeck",
  state: GermanStates.SchleswigHolstein,
  email: "kontakt@hautpartner.de",
  phone: "045181551",
  lat: 53.866787,
  lon: 10.672526,
  webAddress: "https://www.hautpartner.de",
}

const meyer: Doctor = {
  doctorsName: "Dr. Volker Meyer",
  officeName: "Hautarztpraxis Bremerhaven",
  address: "Lindenallee 2, 27572 Bremerhaven",
  state: GermanStates.Bremen,
  email: "meyer.volker@posteo.de",
  phone: "0471972390",
  lat: 53.505126,
  lon: 8.599378,
  webAddress: "https://hautarztbremerhaven.de",
}

const zarnitz: Doctor = {
  doctorsName: "Ferdinand Zarnitz",
  officeName: "Hautarztpraxis Ferdinand Zarnitz",
  address: "Marktpassage 10, 21149 Hamburg",
  state: GermanStates.Hamburg,
  email: "hautarzt.neugraben@gmail.com",
  phone: "040 7015063",
  lat: 53.471191,
  lon: 9.85313,
  webAddress: "https://www.kvhh.net/de/medicalregister/net-kvhh-physician-7505-20274.html",
}

const barnstedt: Doctor = {
  doctorsName: "Dr. Sven Barnstedt",
  officeName: "Gemeinschaftspraxis\n" + "Dr. med. Christopher Nagel\n" + "Dr. med. Sven-Erik Barnstedt",
  address: "Gartenfeldstraße 2, 55218 Ingelheim",
  state: GermanStates.RhinelandPalatinate,
  email: "info@hautarzt-ingelheim.de",
  phone: "06132 71 9848",
  lat: 49.974717,
  lon: 8.056377,
  webAddress: "www.hautarzt-ingelheim.de",
}

const viehmann: Doctor = {
  doctorsName: "Dr. Matthias Viehmann",
  officeName: "Hautarztpraxis Dr. Viehmann",
  address: "An der Johanneskirche 5, 35390 Gießen",
  state: GermanStates.Hessen,
  email: "info@hautarzt-viehmann.de",
  phone: "0641 74083",
  lat: 50.582222,
  lon: 8.672307,
  webAddress: "https://hautarzt-viehmann.de",
}

const bettinger: Doctor = {
  doctorsName: "Dr. Jörg Bettinger",
  officeName: "Praxis Dr. Bettinger",
  address: "Kaiserstraße 72, 76133 Karlsruhe",
  state: GermanStates.BadenWuerttemberg,
  phone: "0721 5163690",
  email: "info@hautaerzte-ka.de",
  lat: 49.01010415410061,
  lon: 8.404283683773674,
  webAddress: "https://hautaerzte-ka.de",
}

const kost: Doctor = {
  doctorsName: "Dr. Ricarda Kost",
  officeName: "Praxis Dr. Ricarda Kost",
  address: "Weberstraße 18, 45879 Gelsenkirchen",
  state: GermanStates.NorthRhineWestphalia,
  phone: "0209 207900",
  email: "praxis@hautarzt-cramer.de",
  lat: 51.50716268382122,
  lon: 7.1017495973817955,
  webAddress: "https://hautarzt-cramer.de",
}

const brennecke: Doctor = {
  doctorsName: "Dr. Nicola Brennecke",
  officeName: "Hautarztpraxis an der Hase",
  address: "Hasestraße 17, 49565 Brahmsche",
  state: GermanStates.LowerSaxony,
  phone: "05461 5787",
  email: "info@hautarztpraxis-an-der-hase.de",
  lat: 52.66935749040519,
  lon: 7.940862439952182,
  webAddress: "https://hautarztpraxis-an-der-hase.de",
}

const weyergraf: Doctor = {
  doctorsName: "Dr. Ansgar Weyergraf",
  officeName: "Hautarztpraxis an der Hase",
  address: "Goethestraße 17, 49610 Quakenbrück",
  state: GermanStates.LowerSaxony,
  phone: "05461 5787",
  email: "info@hautarztpraxis-an-der-hase.de",
  lat: 52.66935749040519,
  lon: 7.940862439952182,
  webAddress: "https://hautarztpraxis-an-der-hase.de",
}

const moeller: Doctor = {
  doctorsName: "Dr. med. Nicola Möller",
  officeName: "Hautarztpraxis Dermatologie im Zentrum in Wiesbaden",
  address: "Friedrichstr. 8, 65185 Wiesbaden",
  state: GermanStates.Hessen,
  phone: "+49 611 378832",
  email: "info@facharztdermatologie.de",
  lat: 50.08053510442679,
  lon: 8.243764924620715,
  webAddress: "https://www.facharztdermatologie.de",
}

const mohamed: Doctor = {
  doctorsName: "Dr. med. Salaheldin Mohamed",
  officeName: "Hautarztpraxis Melsungen",
  address: "Bahnhofstr. 13, 34212 Melsungen",
  state: GermanStates.Hessen,
  phone: "+49 5661 9023000",
  email: "info@hautarztpraxis-melsungen.de",
  lat: 51.132197806574986,
  lon: 9.549226677235502,
  webAddress: "",
}

const koerber: Doctor = {
  doctorsName: "Dr. med. Jenda Körber",
  officeName: "Hautarztpraxis Dr. Körber",
  address: "Töngesgasse 22, 60311 Frankfurt",
  state: GermanStates.Hessen,
  phone: "",
  email: "hautarzt-dr-koerber@t-online.de",
  lat: 50.11372273257029,
  lon: 8.683965368482413,
  webAddress: "https://www.hautarzt-koerber-frankfurt.de",
}

const kiedrowski: Doctor = {
  doctorsName: "Dr. med. Ralph von Kiedrowksi",
  officeName: "Dermatologische Spezial- und Schwerpunktpraxis",
  address: "Kirchstraße 1, 56242 Selters",
  state: GermanStates.RhinelandPalatinate,
  phone: "+49 2626 921450",
  email: "info@praxis-kiedrowski.de",
  lat: 50.529203,
  lon: 7.756201,
  webAddress: "https://www.praxis-kiedrowski.de",
}

// --- Additional team members for practices already listed above ---
// Derma Nord (Dr. Uwe Schwichtenberg), Bremen
const blenkers: Doctor = {
  doctorsName: "Thomas Blenkers",
  officeName: "Derma Nord",
  address: "Kaffeestraße 2, 28779 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 601066",
  email: "anmeldung@derma-nord.de",
  lat: 53.181835899999996,
  lon: 8.575369914538852,
  webAddress: "https://www.derma-nord.de",
}

const zienau: Doctor = {
  doctorsName: "Anke Zienau",
  officeName: "Derma Nord",
  address: "Kaffeestraße 2, 28779 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 601066",
  email: "anmeldung@derma-nord.de",
  lat: 53.181835899999996,
  lon: 8.575369914538852,
  webAddress: "https://www.derma-nord.de",
}

const dellasette: Doctor = {
  doctorsName: "Frederike Dellasette",
  officeName: "Derma Nord",
  address: "Kaffeestraße 2, 28779 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 601066",
  email: "anmeldung@derma-nord.de",
  lat: 53.181835899999996,
  lon: 8.575369914538852,
  webAddress: "https://www.derma-nord.de",
}

const norrenbrock: Doctor = {
  doctorsName: "Simone Norrenbrock",
  officeName: "Derma Nord",
  address: "Kaffeestraße 2, 28779 Bremen",
  state: GermanStates.Bremen,
  phone: "0421 601066",
  email: "anmeldung@derma-nord.de",
  lat: 53.181835899999996,
  lon: 8.575369914538852,
  webAddress: "https://www.derma-nord.de",
}

// Cramer und Kollegen, Gelsenkirchen
const krosta: Doctor = {
  doctorsName: "Iris Krosta",
  officeName: "Hautärztliche Gemeinschaftspraxis Dres. med. Cramer und Kollegen",
  address: "Weberstraße 18, 45879 Alt-Gelsenkirchen ",
  state: GermanStates.NorthRhineWestphalia,
  email: "praxis@hautarzt-cramer.de",
  phone: "0209207900",
  lat: 51.507001,
  lon: 7.10168,
  webAddress: "https://hautarzt-cramer.de",
}

// Hautarztpraxis Dr. Viehmann, Gießen
const dahm: Doctor = {
  doctorsName: "Martha Dahm",
  officeName: "Hautarztpraxis Dr. Viehmann",
  address: "An der Johanneskirche 5, 35390 Gießen",
  state: GermanStates.Hessen,
  email: "info@hautarzt-viehmann.de",
  phone: "0641 74083",
  lat: 50.582222,
  lon: 8.672307,
  webAddress: "https://hautarzt-viehmann.de",
}

// Gemeinschaftspraxis Neumann/Dr. Overbeck, Hann. Münden
const neumann: Doctor = {
  doctorsName: "Thomas Neumann",
  officeName: "Hautärztliche Gemeinschaftspraxis Neumann/Dr. Overbeck",
  address: "Lange Strasse 53, 34345 Hann. Münden",
  state: GermanStates.LowerSaxony,
  email: "info@derma-praxis.eu",
  phone: "05541 2447",
  lat: 51.416775,
  lon: 9.651786,
  webAddress: "https://www.hautarztpraxis-hann-muenden.de",
}

// Hautärzte am Marktplatz (Praxis Dr. Bettinger), Karlsruhe
const saha: Doctor = {
  doctorsName: "Susanne Saha",
  officeName: "Praxis Dr. Bettinger",
  address: "Kaiserstraße 72, 76133 Karlsruhe",
  state: GermanStates.BadenWuerttemberg,
  phone: "0721 5163690",
  email: "info@hautaerzte-ka.de",
  lat: 49.01010415410061,
  lon: 8.404283683773674,
  webAddress: "https://hautaerzte-ka.de",
}

// Hautarztpraxis Prof. Krengel / Dr. Mrowka / Dr. Haase, Lübeck
const krengel: Doctor = {
  doctorsName: "Dr. Sven Krengel",
  officeName: "Hautarztpraxis Prof. Krengel / Dr. Mrowka / Dr. Haase ",
  address: "Lindenplatz 6, 23554 Lübeck",
  state: GermanStates.SchleswigHolstein,
  email: "kontakt@hautpartner.de",
  phone: "045181551",
  lat: 53.866787,
  lon: 10.672526,
  webAddress: "https://www.hautpartner.de",
}

// Hautarztpraxis an der Hase, Bramsche (Brennecke/Weyergraf already listed)
const frick: Doctor = {
  doctorsName: "Stephanie Frick",
  officeName: "Hautarztpraxis an der Hase",



  address: "Hasestraße 17, 49565 Brahmsche",
  state: GermanStates.LowerSaxony,
  phone: "05461 5787",
  email: "info@hautarztpraxis-an-der-hase.de",
  lat: 52.66935749040519,
  lon: 7.940862439952182,
  webAddress: "https://hautarztpraxis-an-der-hase.de",
}

const kempke: Doctor = {
  doctorsName: "Konstanze Kempke",
  officeName: "Hautarztpraxis an der Hase",
  address: "Hasestraße 17, 49565 Brahmsche",
  state: GermanStates.LowerSaxony,
  phone: "05461 5787",
  email: "info@hautarztpraxis-an-der-hase.de",
  lat: 52.66935749040519,
  lon: 7.940862439952182,
  webAddress: "https://hautarztpraxis-an-der-hase.de",
}




// 2026-09-29
const ender: Doctor = {
  doctorsName: "Stephanie Ender",
  officeName: "Enderma Praxis für Dermatologie und Ästhetik",
  address: "Karl-Marx Straße 32, 36456 Barchfeld-Immelborn",
  state: GermanStates.Thuringia,
  phone: "+49 3695 8616240",
  email: "praxis@enderma.de",
  lat: 50.79798001524162,
  lon: 10.306478052212514,
  webAddress: "https://enderma.de/",
}

const fedel: Doctor = {
  doctorsName: "Dr. med. Christoph Fedel",
  officeName: "Hautarztzentrum Böblingen",
  address: "Olgastraße 11, 71032 Böblingen",
  state: GermanStates.BadenWuerttemberg,
  phone: "+49 7031 718330",
  email: "praxis@hautarztzentrum-bb.de",
  lat: 48.68785862005906,
  lon: 9.00712591170613,
  webAddress: "https://hautarztzentrum-bb.de/",
}

const jungmannGeiss: Doctor = {
  doctorsName: "Dr. med. Janina Jungmann-Geiß",
  officeName: "Hautarztzentrum Böblingen",
  address: "Olgastraße 11, 71032 Böblingen",
  state: GermanStates.BadenWuerttemberg,
  phone: "+49 7031 718330",
  email: "praxis@hautarztzentrum-bb.de",
  lat: 48.68785862005906,
  lon: 9.00712591170613,
  webAddress: "https://hautarztzentrum-bb.de/",
}

const ulrich: Doctor = {
  doctorsName: "Dr. med. Stefan Ulrich",
  officeName: "Hautarztpraxis am Markt in Castrop-Rauxel",
  address: "Am Markt 20, 44575 Castrop-Rauxel",
  state: GermanStates.NorthRhineWestphalia,
  phone: "+49 2305 27057",
  email: "praxis@hautarzt-ulrich.de",
  lat: 51.547138038998774,
  lon: 7.3108721127409355,
  webAddress: "https://hautarzt-ulrich.de/",
}

const oberthuer: Doctor = {
  doctorsName: "Dr. med. Frank Oberthür",
  officeName: "Derma Zentrum Grünwald",
  address: "Tölzer Str. 1a, 82031 Grünwald",
  state: GermanStates.Bavaria,
  phone: "+49 89 6415141",
  email: "anfrage@derma-gruenwald.de",
  lat: 48.035091400146484,
  lon: 11.52131462097168,
  webAddress: "https://www.derma-gruenwald.de/home.html",
}

const bandholz: Doctor = {
  doctorsName: "Dr. med. Thyra Caroline Bandholz",
  officeName: "Gemeinschaftspraxis Dres. Brambring/Bandholz",
  address: "Friedrichsorter Straße 2, 24159 Kiel",
  state: GermanStates.SchleswigHolstein,
  phone: "+49 431 393046",
  email: "info@kiel-hautarzt.de",
  lat: 54.39841725749883,
  lon: 10.172739617059968,
  webAddress: "https://kiel-hautarzt.de/",
}

const thierfelder: Doctor = {
  doctorsName: "Dr. med. Anke Thierfelder",
  officeName: "Hautarztpraxis Dr. Anke Thierfelder",
  address: "Stadtweide 101, 23562 Lübeck",
  state: GermanStates.SchleswigHolstein,
  phone: "+49 451 5059597",
  email: "", // keine
  lat: 53.84049176511105,
  lon: 10.703065454578896,
  webAddress: "https://www.anke-thierfelder.de/",
}

const gabr: Doctor = {
  doctorsName: "Dr. med. Karim Magdi Gabr",
  officeName: "Dermatologie Hochrhein",
  address: "Wallstr. 66, 79761 Waldshut-Tiengen",
  state: GermanStates.BadenWuerttemberg,
  phone: "+49 7751 3063244",
  email: "info@dermatologie-hochrhein.de",
  lat: 47.623198040376295,
  lon: 8.211234541397756,
  webAddress: "https://www.dermatologie-hochrhein.de/",
}



export const doctors: Doctor[] = [
  ender,
  fedel,
  jungmannGeiss,
  ulrich,
  oberthuer,
  bandholz,
  thierfelder,
  gabr,
  schwichtenberg,
  lucka,
  toepfer,
  quitschau,
  jagow,
  overbeck,
  ekanayakeBohlig,
  wagner,
  cramer,
  drerup,
  haase,
  meyer,
  zarnitz,
  barnstedt,
  viehmann,
  bettinger,
  kost,
  brennecke,
  weyergraf,
  moeller,
  mohamed,
  koerber,
  kiedrowski,
  blenkers,
  zienau,
  dellasette,
  norrenbrock,
  krosta,
  dahm,
  neumann,
  saha,
  krengel,
  frick,
  kempke,
  behrmann,
  elsner,
  alJebori,
  eilers,
  goppold,
  francois,
  dettmann,
  hoffmann,
  huerkamp,
  schuster,
  zobel,
  huening,
  le,
  ueberschaar,
  mueller,
  matzke,
]

// --- Doctors grouped by office ---

const praxisBehrmannPoel: Doctor[] = [behrmann]
const mvzHautLaserzentrumBremen: Doctor[] = [elsner]
const hautarztpraxisAngelaGoppold: Doctor[] = [goppold]
const hautarztpraxisHuerkampSchuster: Doctor[] = [huerkamp, schuster]
const hautLaserpraxisHagen: Doctor[] = [alJebori]
const curadermLohne: Doctor[] = [eilers, hoffmann, zobel]
const curadermElsfleth: Doctor[] = [dettmann]
const curadermGarrel: Doctor[] = [francois]
const hautarztpraxisSchwelm: Doctor[] = [huening]
const hautarztpraxisLe: Doctor[] = [le]
const dermatologieUeberschaar: Doctor[] = [ueberschaar, mueller]
const hautarztpraxisMatzke: Doctor[] = [matzke]
const dermaNord: Doctor[] = [schwichtenberg, blenkers, zienau, dellasette, norrenbrock]
const dermatologieAmMarkt: Doctor[] = [lucka]
const gemeinschaftspraxisDiessenbacherToepferTams: Doctor[] = [toepfer]
const praxisViktoriaQuitschau: Doctor[] = [quitschau]
const praxisJohannaJagow: Doctor[] = [jagow]
const gemeinschaftspraxisNeumannOverbeck: Doctor[] = [overbeck, neumann]
const aerztehausRahlstedt: Doctor[] = [ekanayakeBohlig]
const hautarztpraxisAmMuehlenkamp: Doctor[] = [wagner]
const gemeinschaftspraxisCramer: Doctor[] = [cramer, krosta]
const hautarztpraxisHaufs: Doctor[] = [drerup]
const hautarztpraxisKrengelMrowkaHaase: Doctor[] = [haase, krengel]
const hautarztpraxisBremerhaven: Doctor[] = [meyer]
const hautarztpraxisFerdinandZarnitz: Doctor[] = [zarnitz]
const gemeinschaftspraxisNagelBarnstedt: Doctor[] = [barnstedt]
const hautarztpraxisViehmann: Doctor[] = [viehmann, dahm]
const praxisBettinger: Doctor[] = [bettinger, saha]
const praxisRicardaKost: Doctor[] = [kost]
const hautarztpraxisAnDerHase: Doctor[] = [brennecke, weyergraf, frick, kempke]
const dermatologieImZentrumWiesbaden: Doctor[] = [moeller]
const hautarztpraxisMelsungen: Doctor[] = [mohamed]
const hautarztpraxisKoerber: Doctor[] = [koerber]
const dermatologischeSchwerpunktpraxis: Doctor[] = [kiedrowski]

export const doctorsByOffice: Doctor[][] = [
  praxisBehrmannPoel,
  mvzHautLaserzentrumBremen,
  hautarztpraxisAngelaGoppold,
  hautarztpraxisHuerkampSchuster,
  hautLaserpraxisHagen,
  curadermLohne,
  curadermElsfleth,
  curadermGarrel,
  hautarztpraxisSchwelm,
  hautarztpraxisLe,
  dermatologieUeberschaar,
  hautarztpraxisMatzke,
  dermaNord,
  dermatologieAmMarkt,
  gemeinschaftspraxisDiessenbacherToepferTams,
  praxisViktoriaQuitschau,
  praxisJohannaJagow,
  gemeinschaftspraxisNeumannOverbeck,
  aerztehausRahlstedt,
  hautarztpraxisAmMuehlenkamp,
  gemeinschaftspraxisCramer,
  hautarztpraxisHaufs,
  hautarztpraxisKrengelMrowkaHaase,
  hautarztpraxisBremerhaven,
  hautarztpraxisFerdinandZarnitz,
  gemeinschaftspraxisNagelBarnstedt,
  hautarztpraxisViehmann,
  praxisBettinger,
  praxisRicardaKost,
  hautarztpraxisAnDerHase,
  dermatologieImZentrumWiesbaden,
  hautarztpraxisMelsungen,
  hautarztpraxisKoerber,
  dermatologischeSchwerpunktpraxis,
]

export const oneDoctorByOffice: Doctor[] = [
  praxisBehrmannPoel[0],
  mvzHautLaserzentrumBremen[0],
  hautarztpraxisAngelaGoppold[0],
  hautarztpraxisHuerkampSchuster[0],
  hautLaserpraxisHagen[0],
  curadermLohne[0],
  curadermElsfleth[0],
  curadermGarrel[0],
  hautarztpraxisSchwelm[0],
  hautarztpraxisLe[0],
  dermatologieUeberschaar[0],
  hautarztpraxisMatzke[0],
  dermaNord[0],
  dermatologieAmMarkt[0],
  gemeinschaftspraxisDiessenbacherToepferTams[0],
  praxisViktoriaQuitschau[0],
  praxisJohannaJagow[0],
  gemeinschaftspraxisNeumannOverbeck[0],
  aerztehausRahlstedt[0],
  hautarztpraxisAmMuehlenkamp[0],
  gemeinschaftspraxisCramer[0],
  hautarztpraxisHaufs[0],
  hautarztpraxisKrengelMrowkaHaase[0],
  hautarztpraxisBremerhaven[0],
  hautarztpraxisFerdinandZarnitz[0],
  gemeinschaftspraxisNagelBarnstedt[0],
  hautarztpraxisViehmann[0],
  praxisBettinger[0],
  praxisRicardaKost[0],
  hautarztpraxisAnDerHase[0],
  dermatologieImZentrumWiesbaden[0],
  hautarztpraxisMelsungen[0],
  hautarztpraxisKoerber[0],
  dermatologischeSchwerpunktpraxis[0],
]